export default __webpack_public_path__ + "static/media/gallery_05.4721c0ad.jpg";